import React from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'

export default function ChartCard({ title, subtitle, children }) {
    return (
        <Card
            sx={{
                height: '100%',
                border: '1px solid #E2E8F0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                transition: 'box-shadow 0.2s ease',
                '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                },
            }}
        >
            <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                {title && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1E293B' }}>
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography variant="caption" sx={{ color: '#64748B' }}>
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                )}
                {children}
            </CardContent>
        </Card>
    )
}
